import { createBrowserRouter } from 'react-router-dom';
import { RequireAuth } from './layouts/RequireAuth';
import { RequireAccess } from './layouts/RequireAccess';
import { RootLayout } from './layouts/RootLayout';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { Employees } from './pages/Employees';
import { Medical, MedicalRecordDetail, EmployeeMedicalCard } from './pages/Medical';
import { Training, TrainingRecordDetail, EmployeeTrainingCard } from './pages/Training';
// import { Sout, SoutRecordDetail } from './pages/Sout';
import { Risks, RiskCardDetail } from './pages/Risks';
import { Siz, PpeNormDetail } from './pages/Siz';
import { Documents, DocumentRecordDetail } from './pages/Documents';
import { Reports } from './pages/Reports';
import { Admin } from './pages/Admin';

export const router = createBrowserRouter([
  { path: '/login', element: <Login /> },
  {
    element: <RequireAuth />,
    children: [
      {
        element: <RequireAccess />,
        children: [
          {
            path: '/',
            element: <RootLayout />,
            children: [
              { index: true, element: <Dashboard /> },
              { path: 'employees', element: <Employees /> },
              { path: 'medical/records/:recordId', element: <MedicalRecordDetail /> },
              { path: 'medical/employee/:employeeId', element: <EmployeeMedicalCard /> },
              { path: 'medical', element: <Medical /> },
              { path: 'training/records/:recordId', element: <TrainingRecordDetail /> },
              { path: 'training/employee/:employeeId', element: <EmployeeTrainingCard /> },
              { path: 'training', element: <Training /> },
              { path: 'risks/cards/:cardId', element: <RiskCardDetail /> },
              { path: 'risks', element: <Risks /> },
              { path: 'siz/norms/:normId', element: <PpeNormDetail /> },
              { path: 'siz', element: <Siz /> },
              // { path: 'sout/records/:recordId', element: <SoutRecordDetail /> },
              // { path: 'sout', element: <Sout /> },
              { path: 'documents/records/:documentId', element: <DocumentRecordDetail /> },
              { path: 'documents', element: <Documents /> },
              { path: 'reports', element: <Reports /> },
              { path: 'admin', element: <Admin /> },
            ],
          },
        ],
      },
    ],
  },
]);
